import {CLEAR_TRIGGER, TRIGGER} from "../redux_constants/triggers.constant";

export const trigger = (trigger) => ({
    type: TRIGGER,
    trigger,
});

export const clear = (key) => ({
    type: CLEAR_TRIGGER,
    key,
});

export const expandAnnotation = id => trigger({expandAnnotation: id});

export const selectAnnotation = id => trigger({selectAnnotation: id});
